import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaioutstationcab() {



    const cardData = {
"keyword": "Mumbai Outstation Cabs",

"headingDescription":
  "Om Sai Cab offers reliable and comfortable Mumbai Outstation Cabs service for travelers looking for safe, affordable, and convenient long-distance travel from Mumbai to various destinations across Maharashtra and India. Whether you are planning a weekend getaway, family vacation, pilgrimage, business trip, or group travel, our outstation taxi service ensures a smooth and stress-free journey. With experienced drivers familiar with highway and intercity routes, clean air-conditioned vehicles maintained for long-distance comfort, and transparent pricing with no hidden charges, we provide a dependable travel solution for every passenger. Our fleet includes sedans, SUVs, Innova cars, tempo travellers, and premium vehicles suitable for solo travelers, families, and groups.",

"topPlaces": [
  {
    "title": "Lonavala",
    "description":
      "Lonavala is a popular hill station near Mumbai known for scenic valleys, waterfalls, forts, and pleasant weather especially during monsoon."
  },
  {
    "title": "Mahabaleshwar",
    "description":
      "Mahabaleshwar is a famous hill station known for strawberry farms, viewpoints, lakes, and lush green Western Ghats scenery."
  },
  {
    "title": "Goa",
    "description":
      "Goa is India’s most popular beach destination known for sandy beaches, nightlife, Portuguese heritage, and water sports activities."
  },
  {
    "title": "Shirdi",
    "description":
      "Shirdi is a major pilgrimage town known for Sai Baba Temple, attracting devotees from across India throughout the year."
  },
  {
    "title": "Pune",
    "description":
      "Pune is a major cultural and educational city known for historical forts, modern lifestyle, and nearby hill stations."
  },
  {
    "title": "Nashik",
    "description":
      "Nashik is a spiritual and wine capital of India known for Trimbakeshwar Temple, vineyards, and scenic river landscapes."
  },
  {
    "title": "Alibaug",
    "description":
      "Alibaug is a coastal getaway near Mumbai known for beaches, sea forts, and relaxing weekend trips."
  },
  {
    "title": "Aurangabad",
    "description":
      "Aurangabad is known for Ajanta and Ellora Caves, UNESCO World Heritage Sites showcasing ancient rock-cut architecture."
  },
  {
    "title": "Matheran",
    "description":
      "Matheran is a peaceful hill station near Mumbai known for vehicle-free roads, viewpoints, and natural beauty."
  },
  {
    "title": "Igatpuri",
    "description":
      "Igatpuri is a scenic hill station known for mountains, Vipassana International Academy, and lush green landscapes."
  }
],



services: [
  {
    name: "Best Outstation Cab Service in Mumbai",
    description: "Best outstation cab service in Mumbai provides premium long-distance transportation for travelers planning smooth intercity road journeys. Vehicles ensure reliable highway travel suitable for tourism trips, pilgrimage travel, executive journeys, and family vacations. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby areas across Mumbai. Flexible booking options allow convenient premium outstation cab reservations."
  },
  {
    name: "Outstation Cab Booking Mumbai",
    description: "Outstation cab booking Mumbai service provides quick and convenient transportation reservations for travelers planning comfortable intercity road journeys. Comfortable vehicles ensure smooth highway travel suitable for tourism trips, family holidays, business travel, and sightseeing tours. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby airport locations across Mumbai. Flexible booking options allow convenient outstation cab reservations."
  },
  {
    name: "Outstation Cab Service in Mumbai",
    description: "Outstation cab service in Mumbai provides reliable transportation solutions for travelers planning long-distance road journeys from Mumbai. Vehicles ensure dependable highway travel suitable for tourism travel, executive trips, pilgrimage tours, and family vacations. Professional chauffeurs ensure safe driving and smooth transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Mumbai. Flexible booking options allow convenient outstation cab service reservations."
  },
  {
    name: "Outstation Taxi Service in Mumbai",
    description: "Outstation taxi service in Mumbai offers dependable transportation for travelers seeking comfortable intercity road travel. Vehicles ensure smooth highway journeys suitable for tourism trips, family outings, business travel, and holiday travel. Professional chauffeurs ensure reliable pickup and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby airport areas across Mumbai. Flexible booking options allow convenient outstation taxi reservations."
  },
  {
    name: "Cab Booking in Mumbai for Outstation",
    description: "Cab booking in Mumbai for outstation service provides easy transportation reservations for travelers planning comfortable long-distance road journeys. Vehicles ensure reliable highway travel suitable for tourism travel, family vacations, executive travel, and pilgrimage trips. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Mumbai. Flexible booking options allow convenient outstation cab reservations."
  },
  {
    name: "Cab Service in Mumbai for Outstation",
    description: "Cab service in Mumbai for outstation provides dependable transportation for travelers seeking smooth and safe intercity road travel. Comfortable vehicles ensure reliable highway journeys suitable for sightseeing tours, tourism trips, family vacations, and executive journeys. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby areas across Mumbai. Flexible booking options allow convenient outstation cab service reservations."
  },
  {
    name: "Car for Outstation from Mumbai",
    description: "Car for outstation from Mumbai service provides spacious and comfortable vehicles for travelers planning private long-distance road journeys. Vehicles ensure smooth highway travel suitable for tourism travel, family holidays, pilgrimage tours, and executive travel. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby airport areas across Mumbai. Flexible booking options allow convenient outstation car reservations."
  },
  {
    name: "Car Hire for Outstation in Mumbai",
    description: "Car hire for outstation in Mumbai service offers premium transportation with comfortable vehicles for smooth intercity road travel. Vehicles ensure reliable highway journeys suitable for tourism trips, family vacations, business travel, and holiday travel. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby locations across Mumbai. Flexible booking options allow convenient outstation car hire reservations."
  },
  {
    name: "Car on Rent for Outstation in Mumbai",
    description: "Car on rent for outstation in Mumbai service provides reliable transportation for travelers planning comfortable long-distance road journeys. Vehicles ensure smooth highway travel suitable for sightseeing tours, tourism travel, and family holidays. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby airport areas across Mumbai. Flexible booking options allow convenient outstation car rental reservations."
  },
  {
    name: "Cheapest Outstation Cabs from Mumbai",
    description: "Cheapest outstation cabs from Mumbai service offers budget-friendly transportation for travelers planning economical intercity road journeys. Comfortable vehicles ensure reliable highway travel suitable for tourism trips, family vacations, pilgrimage tours, and executive travel. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Mumbai. Flexible booking options allow convenient low-cost outstation cab reservations."
  },
  {
    name: "Hire a Cab in Mumbai",
    description: "Hire a cab in Mumbai service provides dependable transportation for travelers planning smooth local and outstation road journeys. Vehicles ensure reliable city and highway travel suitable for airport transfers, tourism trips, business travel, and family outings. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby airport locations across Mumbai. Flexible booking options allow convenient cab hire reservations."
  },
  {
    name: "Hire Cab Mumbai",
    description: "Hire cab Mumbai service offers comfortable transportation with dependable vehicles for local and long-distance travel requirements. Vehicles ensure smooth city and highway journeys suitable for airport transfers, tourism travel, executive trips, and family vacations. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby areas across Mumbai. Flexible booking options allow convenient cab hire reservations."
  },
  {
    name: "Mumbai Outstation Taxi",
    description: "Mumbai outstation taxi service provides dependable transportation for travelers planning comfortable intercity road journeys from Mumbai. Vehicles ensure reliable highway travel suitable for tourism trips, family holidays, pilgrimage tours, and executive journeys. Professional chauffeurs ensure punctual pickup and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby locations across Mumbai. Flexible booking options allow convenient outstation taxi reservations."
  },
  {
    name: "Outstation Cars in Mumbai",
    description: "Outstation cars in Mumbai service provides spacious and comfortable vehicles for travelers planning private long-distance road journeys. Vehicles ensure smooth highway travel suitable for tourism travel, family vacations, executive travel, and holiday trips. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby airport areas across Mumbai. Flexible booking options allow convenient outstation car reservations."
  },
  {
    name: "Taxi Service in Mumbai for Outstation",
    description: "Taxi service in Mumbai for outstation offers reliable transportation solutions for travelers planning safe and smooth intercity road travel. Comfortable vehicles ensure dependable highway journeys suitable for tourism trips, pilgrimage tours, executive travel, and family vacations. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby areas across Mumbai. Flexible booking options allow convenient outstation taxi reservations."
  },
  {
    name: "Mumbai to Outstation Cabs",
    description: "Mumbai to outstation cabs service provides dependable transportation for travelers planning comfortable long-distance road journeys from Mumbai. Vehicles ensure smooth highway travel suitable for tourism travel, family vacations, executive trips, and sightseeing tours. Professional chauffeurs ensure punctual pickup and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby locations across Mumbai. Flexible booking options allow convenient outstation cab reservations."
  },
  {
    name: "Mumbai to Shirdi Cabs Round Trip",
    description: "Mumbai to Shirdi cabs round trip service provides comfortable transportation for travelers planning pilgrimage road journeys with return travel options. Vehicles ensure smooth highway travel suitable for religious travel, family trips, and tourism journeys. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby airport locations across Mumbai. Flexible booking options allow convenient Shirdi round trip cab reservations."
  },
  {
    name: "Mumbai to Lonavala Round Trip Taxi",
    description: "Mumbai to Lonavala round trip taxi service offers dependable transportation for travelers planning comfortable hill station road journeys with return travel. Vehicles ensure reliable highway and ghat travel suitable for tourism trips, sightseeing tours, and family outings. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Mumbai. Flexible booking options allow convenient Lonavala round trip taxi reservations."
  },
  {
    name: "Mumbai to Shirdi Round Trip Taxi Fare",
    description: "Mumbai to Shirdi round trip taxi fare service provides affordable and transparent transportation pricing for travelers planning pilgrimage road journeys. Comfortable vehicles ensure smooth highway travel suitable for family trips, tourism travel, and religious travel. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby airport areas across Mumbai. Flexible booking options allow convenient Shirdi round trip taxi reservations."
  },
  {
    name: "Mumbai to Hyderabad Cab",
    description: "Mumbai to Hyderabad cab service provides reliable transportation for travelers planning comfortable interstate road journeys from Mumbai. Vehicles ensure smooth highway travel suitable for tourism travel, executive trips, family vacations, and long-distance travel. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Mumbai. Flexible booking options allow convenient Hyderabad cab reservations."
  },
  {
    name: "Mumbai to Bangalore Cab",
    description: "Mumbai to Bangalore cab service offers dependable transportation for travelers planning smooth interstate road journeys to Bangalore. Vehicles ensure reliable highway travel suitable for executive travel, tourism trips, family vacations, and business journeys. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby airport locations across Mumbai. Flexible booking options allow convenient Bangalore cab reservations."
  },
  {
    name: "Mumbai to Bangalore Taxi",
    description: "Mumbai to Bangalore taxi service provides comfortable transportation for travelers planning long-distance interstate road journeys. Vehicles ensure smooth highway travel suitable for tourism trips, executive travel, family vacations, and holiday travel. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Mumbai. Flexible booking options allow convenient Bangalore taxi reservations."
  },
  {
    name: "Mumbai to Telangana Cab",
    description: "Mumbai to Telangana cab service provides dependable transportation for travelers planning comfortable interstate road journeys from Mumbai. Vehicles ensure reliable highway travel suitable for tourism travel, executive trips, family vacations, and business travel. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby airport areas across Mumbai. Flexible booking options allow convenient Telangana cab reservations."
  },
  {
    name: "Mumbai to Belgaum Taxi",
    description: "Mumbai to Belgaum taxi service offers reliable transportation for travelers planning smooth interstate road journeys from Mumbai to Belgaum. Vehicles ensure comfortable highway travel suitable for tourism trips, family holidays, and executive travel. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Mumbai. Flexible booking options allow convenient Belgaum taxi reservations."
  },
  {
    name: "Mumbai to Belgaum Cab",
    description: "Mumbai to Belgaum cab service provides comfortable transportation for travelers planning dependable interstate road journeys. Vehicles ensure smooth highway travel suitable for tourism travel, family vacations, and business trips. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby airport areas across Mumbai. Flexible booking options allow convenient Belgaum cab reservations."
  },
  {
    name: "Mumbai to Chennai Cab",
    description: "Mumbai to Chennai cab service provides reliable long-distance transportation for travelers planning interstate road journeys from Mumbai to Chennai. Vehicles ensure smooth highway travel suitable for tourism trips, executive travel, family vacations, and business journeys. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Mumbai. Flexible booking options allow convenient Chennai cab reservations."
  },
  {
    name: "Reliable Outstation Cab Mumbai",
    description: "Reliable outstation cab Mumbai service provides dependable transportation solutions for travelers planning safe and smooth intercity road journeys. Comfortable vehicles ensure reliable highway travel suitable for tourism trips, pilgrimage tours, family vacations, and executive travel. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby airport locations across Mumbai. Flexible booking options allow convenient reliable outstation cab reservations."
  }
],

tableData: [
  ["Best Outstation Cab Service in Mumbai", "Outstation Cab Booking Mumbai"],
  ["Outstation Cab Service in Mumbai", "Outstation Taxi Service in Mumbai"],
  ["Cab Booking in Mumbai for Outstation", "Cab Service in Mumbai for Outstation"],
  ["Car for Outstation from Mumbai", "Car Hire for Outstation in Mumbai"],
  ["Car on Rent for Outstation in Mumbai", "Cheapest Outstation Cabs from Mumbai"],
  ["Hire a Cab in Mumbai", "Hire Cab Mumbai"],
  ["Mumbai Outstation Taxi", "Outstation Cars in Mumbai"],
  ["Taxi Service in Mumbai for Outstation", "Mumbai to Outstation Cabs"],
  ["Mumbai to Shirdi Cabs Round Trip", "Mumbai to Lonavala Round Trip Taxi"],
  ["Mumbai to Shirdi Round Trip Taxi Fare", "Mumbai to Hyderabad Cab"],
  ["Mumbai to Bangalore Cab", "Mumbai to Bangalore Taxi"],
  ["Mumbai to Telangana Cab", "Mumbai to Belgaum Taxi"],
  ["Mumbai to Belgaum Cab", "Mumbai to Chennai Cab"],
  ["Reliable Outstation Cab Mumbai", "Best Outstation Cab Service in Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Reliable Mumbai Outstation Cab Service",
    WhyChoosedescription: "Om Sai Cab Service provides reliable Mumbai outstation cab service with professional drivers, comfortable vehicles, and smooth long-distance travel for families, tourists, and corporate travelers."
  },
  {
    WhyChooseheading: "Affordable Mumbai Outstation Taxi Fare",
    WhyChoosedescription: "Our Mumbai outstation taxi service offers affordable pricing with transparent fare details and no hidden charges for one-way and round-trip travel bookings."
  },
  {
    WhyChooseheading: "24/7 Mumbai Outstation Cab Availability",
    WhyChoosedescription: "Om Sai Cab Service operates 24 hours a day for Mumbai outstation cab bookings including airport transfers, holiday trips, business travel, family vacations, and emergency journeys."
  },
  {
    WhyChooseheading: "Comfortable AC Cabs for Long Distance Travel",
    WhyChoosedescription: "All Mumbai outstation taxis are fully air-conditioned, sanitized, spacious, and regularly maintained for smooth and comfortable highway travel experiences."
  },
  {
    WhyChooseheading: "One Way & Round Trip Outstation Cab Booking",
    WhyChoosedescription: "Customers can choose one-way Mumbai outstation cabs, round-trip taxi bookings, return travel options, and customized outstation tour packages."
  },
  {
    WhyChooseheading: "Wide Range of Vehicle Choices",
    WhyChoosedescription: "Om Sai Cab Service offers sedan cars, Ertiga, Innova, Innova Crysta, SUVs, luxury vehicles, and Tempo Travellers suitable for solo travelers, families, tourists, and group tours."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "We provide convenient pickup service from Mumbai Airport, Navi Mumbai, Thane, hotels, homes, railway stations, offices, and all major Mumbai locations."
  },
  {
    WhyChooseheading: "Experienced Drivers for Highway Routes",
    WhyChoosedescription: "Our experienced drivers are familiar with Maharashtra highways, hill station routes, coastal roads, and interstate travel to ensure safe driving and timely arrival."
  }
]
};

const faqData = [
  {
    question: "What is Mumbai outstation cab service?",
    answer: "Mumbai outstation cab service provides comfortable taxi transportation from Mumbai to nearby cities, hill stations, tourist destinations, and interstate locations."
  },
  {
    question: "Is Mumbai outstation cab service available 24 hours?",
    answer: "Yes, Om Sai Cab Service provides 24/7 Mumbai outstation taxi service."
  },
  {
    question: "Which vehicles are available for Mumbai outstation travel?",
    answer: "Customers can choose sedan taxis, Ertiga, Innova, Innova Crysta, SUVs, luxury cars, and Tempo Travellers."
  },
  {
    question: "Can I book one-way and round-trip outstation cabs from Mumbai?",
    answer: "Yes, one-way as well as round-trip Mumbai outstation cab bookings are available."
  },
  {
    question: "Do you provide Mumbai Airport pickup for outstation travel?",
    answer: "Yes, Om Sai Cab Service provides airport pickup and drop service for outstation taxi travel."
  },
  {
    question: "Are all Mumbai outstation taxis air-conditioned?",
    answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable long-distance travel."
  },
  {
    question: "Can I book Mumbai outstation cab service online?",
    answer: "Yes, customers can easily book Mumbai outstation cab service online or through phone booking."
  },
  {
    question: "Which destinations are covered under Mumbai outstation taxi service?",
    answer: "Popular destinations include Goa, Pune, Mahabaleshwar, Lonavala, Nashik, Shirdi, Alibaug, Kolhapur, and many more."
  },
  {
    question: "Are Mumbai outstation cab fares transparent?",
    answer: "Yes, Om Sai Cab Service provides affordable and transparent pricing without hidden charges."
  },
  {
    question: "Is advance booking available for Mumbai outstation cabs?",
    answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak tourist seasons."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Deshmukh",
    feedback: "Om Sai Cab Service made our Mumbai outstation travel very comfortable. The driver was experienced, and the journey felt safe and well-managed throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priya Kulkarni",
    feedback: "Our outstation travel from Mumbai with Om Sai Cab Service was smooth and hassle-free. The cab was clean, and the ride was enjoyable even on long distances.",
    rating: 5
  }
];














    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai to Goa Cab", link: "Mumbai-to-Goa-Cab" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Goa Cab Booking", link: "Mumbai-to-Goa-Cab-Booking" },
        { place: "/images/keyword/3.jpg", text: "Navi Mumbai to Goa Cab Service", link: "Navi-Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/4.jpg", text: "Mumbai Airport to Goa Cab", link: "Mumbai-Airport-to-Goa-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Goa Cab Service", link: "Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Best Mumbai to Goa Cab Service", link: "Best-Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/7.jpg", text: "Thane to Goa Cabs", link: "Thane-to-Goa-Cabs" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Goa Innova Crysta Cab", link: "Mumbai-to-Goa-Innova-Crysta-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Goa One Way Cab", link: "Mumbai-to-Goa-One-Way-Cab" },
        { place: "/images/keyword/10.jpg", text: "Goa Cabs Service", link: "Goa-Cabs-Service" },
        { place: "/images/keyword/11.jpg", text: "Goa to Mumbai Cab", link: "Goa-to-Mumbai-Cab" },
        { place: "/images/keyword/12.jpg", text: "Goa to Navi Mumbai Cab", link: "Goa-to-Navi-Mumbai-Cab" },
        { place: "/images/keyword/13.jpg", text: "Goa to Mumbai Airport Cab", link: "Goa-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/14.jpg", text: "Goa to Mumbai One Way Cab", link: "Goa-to-Mumbai-One-Way-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/16.jpg", text: "Lonavala to Mumbai Cab", link: "Lonavala-to-Mumbai-Cab" },
        { place: "/images/keyword/17.jpg", text: "Best Lonavala to Navi Mumbai Cab", link: "Best-Lonavala-to-Navi-Mumbai-Cab" },
        { place: "/images/keyword/18.jpg", text: "Navi Mumbai Airport Cab", link: "Navi-Mumbai-Airport-Cab" },
        { place: "/images/keyword/19.jpg", text: "Navi Mumbai Cab Service", link: "Navi-Mumbai-Cab-Service" },
        { place: "/images/keyword/20.jpg", text: "Kharghar Taxi Services", link: "Kharghar-Taxi-Services" },
        { place: "/images/keyword/21.jpg", text: "Mumbai Airport Cabs", link: "Mumbai-Airport-Cabs" },
        { place: "/images/keyword/22.jpg", text: "Mumbai Cab Service", link: "Mumbai-Cab-Service" },
        { place: "/images/keyword/23.jpg", text: "Mumbai Online Cab Service", link: "Mumbai-Online-Cab-Service" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/25.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/26.jpg", text: "Innova Crysta On Rent in Mumbai", link: "Innova-Crysta-On-Rent-in-Mumbai" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Outstation Cab Service",
  "image": "http://www.omsaicabservice.com/assets/images/mumbai-outstation-cabs.jpg",
  "description": "Book Mumbai outstation cab service with Om Sai Cab Service for one-way and round-trip travel. Affordable Sedan, SUV, Innova, and luxury taxis available for Shirdi, Lonavala, Hyderabad, and other intercity routes with 24x7 support.",
  "brand": {
    "@type": "Brand",
    "name": "Om Sai Cab Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "http://www.omsaicabservice.com/mumbai-outstation-cabs"
  }
};





    return (
        <div>

<Helmet>
  <title>
    Mumbai Outstation Cabs | One Way & Round Trip Taxi | +91 9594849797
  </title>

  <meta
    name="description"
    content="Book Mumbai outstation cab service for one-way and round trips. Cheapest and best intercity taxi service available for Shirdi, Lonavala, Hyderabad, and other destinations with Sedan, SUV, Innova, and luxury cars."
  />

  <meta
    name="keywords"
    content="Best outstation cab service in mumbai, Outstation cab booking mumbai, outstation cab service in mumbai, outstation taxi service in mumbai, cab booking in mumbai for outstation, cab service in mumbai for outstation, car for outstation from mumbai, car hire for outstation in mumbai, car on rent for outstation in mumbai, cheapest outstation cabs from mumbai, Hire a cab in mumbai, hire cab mumbai, mumbai outstation taxi, outstation cars in mumbai, taxi service in mumbai for outstation, mumbai to outstation cabs, mumbai to shirdi cabs round trip, mumbai to lonavala round trip taxi, mumbai to shirdi round trip taxi fare, mumbai to hyderabad"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <div className="breadcrumb-bar">
                <div className="container">
                    <div className="row align-items-center text-center">
                        <div className="col-md-12 col-12">
                            <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/25.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FFCC00', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Om Sai Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Om Sai Cab</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Om Sai Cab </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                             <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919594849797" className="pc-call">+91 9594849797</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919594849797"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919594849797" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@omsaicabservice.com" className="pc-email">
                                            booking@omsaicabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Om Sai Cab Service</strong><br />
                                            Shree Vishal CHS Ltd., Plot No.17,
                                            Sector 18, Kopar Khairane, Navi Mumbai,
                                            Maharashtra- India - 400709
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaioutstationcab;